import { render } from "./TribesSelector.vue?vue&type=template&id=06cebb76&ts=true"
import script from "./TribesSelector.vue?vue&type=script&lang=ts"
export * from "./TribesSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__